import React, { useCallback, useContext, useEffect, useState } from "react";
import Loading from "@/components/Loading";
import "./index.less";
import { ContextMenuMode } from "../../types";
import { Dropdown, Tooltip } from "antd";
import events from "../../context/events";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { notUseJoySpaceOffline } from "../../util";
import { useNavigator } from "@/utils/NetworkCheck";
import noDataPicture from "@/assets/img/no-content1.png";
import { changeEgovUrl } from "@/utils/tools";
import { time } from "../../util";

interface IProps {
  list: any[];
  loading?: boolean;
  title?: string;
  emptyText?: string;
  callback?: Function;
  renderActions?: (item: any, contextMenuMode?: ContextMenuMode) => React.ReactElement;
}

const KnowledgeCardList = (props: IProps) => {
  const { title = "", loading = false, list = [], emptyText = "", renderActions, callback } = props;
  const [visible, setVisible] = useState(false);
  const [newItem, setNewItem] = useState<any>({});
  const { onLine, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const defaultIconURL = appRuntimeEnv.joyspaceHost + "/static/icons/Webicon/wiki.png";

  const hideContextMenus = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    events.on("knowledge:hideContextMenus", hideContextMenus);
    return () => {
      events.off("knowledge:hideContextMenus", hideContextMenus);
    };
  }, [hideContextMenus]);

  const onContextMenu = useCallback(
    (event) => {
      if (!onLine || !list.length) {
        return;
      }
      hideContextMenus();
      if (event?.target) {
        const attr = (event.target as any).getAttribute("data-menu");
        if (attr === "contextMenu") {
          return;
        }
      }
      setVisible(true);
    },
    [list.length, onLine]
  );

  return (
    <div className="knowledge-card-box" style={{ marginTop: title ? "0px" : "16px" }}>
      {title && <h3 className="knowledge-card-header">{title}</h3>}
      {!loading && list.length > 0 && (
        <Dropdown
          overlay={() => {
            return renderActions?.(newItem, ContextMenuMode.ContextMenu) || <span />;
          }}
          visible={visible}
          trigger={["contextMenu"]}
          getPopupContainer={() => {
            const node =
              (document.getElementsByClassName(
                "knowledge-card-ppup-container"
              )?.[0] as HTMLElement) || document.body;
            return node;
          }}
        >
          <div
            data-menu="contextMenu"
            className="knowledge-card-list"
            onContextMenu={onContextMenu}
          >
            {list.map((item: any) => {
              return (
                <div
                  className="card-item"
                  onContextMenu={() => {
                    setNewItem(item);
                  }}
                  onClick={(e: any) => {
                    callback?.(e, item);
                  }}
                >
                  <div className="card-item-top">
                    <img
                      src={item.icon ? changeEgovUrl(item.icon) : defaultIconURL}
                      className="card-item-icon"
                    />
                    <div className="card-item-detail">
                      <Tooltip title={item.name} placement="topLeft">
                        <span className="card-item-title">{item.name}</span>
                      </Tooltip>
                      <Tooltip title={item.description} placement="topLeft">
                        <div className="card-item-desc">{item.description}</div>
                      </Tooltip>
                    </div>
                  </div>
                  {/* <div className="card-item-time">最近打开于{time.format(item.openTime)}</div> */}
                  <div className="card-item-actions">{renderActions?.(item)}</div>
                </div>
              );
            })}
          </div>
        </Dropdown>
      )}
      {loading && !list.length && (
        <div className="knowledge-card-list-no-data">
          <div className="list-table-loading">
            <Loading />
          </div>
        </div>
      )}
      {!loading && !list.length && (
        <div className="knowledge-card-list-no-data">
          {notUseJoySpaceOffline() || useNavigator.onLine ? (
            <div className="pm-doc-nodata">
              <img src={noDataPicture} />
              <p>暂无内容</p>
            </div>
          ) : (
            <div className="pm-doc-nodata">
              <img src={noDataPicture} />
              <p>暂无缓存信息，请联网后查看</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KnowledgeCardList;
